(function() {
    'use strict';
    let closestLocation; 
    let currentUserLatLong;
    let closestLocationDataBlocks;
    let currentClosestLocationClass; 
    const locationSelectLinks = document.querySelectorAll('.location-select-link');
    const formCheckInput = document.querySelector('.form-check-input');
    const ourLocationsLatLong = [{
            location: 'sanDiego',
            locationClass: 'san-diego',
            lat: 32.715736,
            long: -117.161087
        },
        {
            location: 'greaterLosAngeles',
            locationClass: 'greater-los-angeles',
            lat: 34.052235,
            long: -118.243683
        },
        {
            location: 'bayArea',
            locationClass: 'bay-area',
            lat: 37.774929,
            long: -122.419418
        },
        {
            location: 'sacramento',
            locationClass: 'sacramento',
            lat: 38.581573,
            long: -121.494400
        },
        {
            location: 'washingtonDc',
            locationClass: 'washington-dc',
            lat: 38.907192,
            long: -77.036873
        },
        {
            location: 'tokyo',
            locationClass: 'tokyo',
            lat: 35.689487,
            long: 139.691711
        }
    ];
    
    const blockContainers = document.querySelectorAll('.two-col-with-image');

    const resizeBackground = () => {
		blockContainers.forEach((blockContainer) => {
			const blockContainerHeight = `${blockContainer.offsetHeight}px`;
			blockContainer.querySelectorAll('.background-col').forEach((block) => {
				block.style.height = blockContainerHeight;
			});
		});
	};

    /* Location Services  
    * Get location, Get Distance, calculate closest Biocom location
    */
    const getLocation = () => {
        const distances = [];
        // Determine if location services are available
        if (navigator && navigator.geolocation) {
            // Location services available, get full location of current user
            navigator.geolocation.getCurrentPosition(getLocationSuccess, getLocationError);
        } else {
            // Warn user that location services will not work properly
            console.error('Error! Geolocation services unavailable.');
        }
    };

    const getLocationSuccess = (position) => {
        const distances = [];
        currentUserLatLong = {
            lat: position.coords.latitude,
            long: position.coords.longitude
        };
        ourLocationsLatLong.forEach(location =>
            distances.push({
                location: location.location,
                locationClass: location.locationClass,
                lat: location.lat,
                long: location.long,
                distanceToCurrentLocation: Math.ceil(getDistance(currentUserLatLong.lat, currentUserLatLong.long, location.lat, location.long, "M"))
            })
        );
        closestLocation = determineClosestLocation(distances);
        currentClosestLocationClass = closestLocation.locationClass;
        setCookie('biocom_location_service', closestLocation.location, 7);
    };

    const getLocationError = (error) => {
        console.error('Error! There was a problem getting your location: ', error);
    };

    // returns closest location obj from ourLocationsLatLong
    const determineClosestLocation = (distances) => {
        return distances.reduce((prev, current) => {
            return (prev.distanceToCurrentLocation < current.distanceToCurrentLocation) ? prev : current
        });
    };

    const getDistance = (lat1, lon1, lat2, lon2, unit) => {
        // Default unit is "M" for miles because 'murica
        const radlat1 = Math.PI * lat1 / 180;
        const radlat2 = Math.PI * lat2 / 180;
        const theta = lon1 - lon2;
        const radtheta = Math.PI * theta / 180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        // Kilometers (The sane measurement)
        if (unit === "K") {
            dist = dist * 1.609344;
        }
        // Nautical Miles (Why not? Ahoy, matey!)
        if (unit === "N") {
            dist = dist * 0.8684;
        }
        return dist;
    };

    /* Local Storage handlers
    * Get (Check), Set
    */
    const setLocalStorage = (boolean) => {
        window.localStorage.setItem('biocom_location_services_active', boolean);
    };

    const checkLocalStorage = () => {
        return window.localStorage.getItem('biocom_location_services_active');
    };

    /* Cookie Handling 
    * Set, Get, Delete, Check
    */
    const cookieNameToCSSClass = (input) => {
        let result = input.replace(/([A-Z]+)/g, ",$1").replace(/^,/, "").toLowerCase();
        return result.split(",").filter((el) => {
            return el !== "";
        }).join("-");
    };

    const setCookie = (cookieKey, cookieValue, expirationDays) => {
        let expiryDate = '';
        if (expirationDays) {
          const date = new Date();
          date.setTime(`${date.getTime()}${(expirationDays || 30 * 24 * 60 * 60 * 1000)}`);
          expiryDate = `; expiryDate=" ${date.toUTCString()}`;
        }
        document.cookie = `${cookieKey}=${cookieValue || ''}${expiryDate}; path=/`;
        setLocalStorage(true);
        toggleBlockDataState(getCookie(), checkLocalStorage(), false);
    };

    const getCookie = () => {
        const cookieKey = 'biocom_location_service';
        let cookieName = `${cookieKey}=`;
        let cookieArray = document.cookie.split(';');
      
        for (let cookie of cookieArray) {
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
    };
    
    const deleteCookie = (name) => {
        setLocalStorage(false);
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'`;
    };

    const checkCookie = (checkAttempt) => {
        const cookie = getCookie();
        const localStorageActiveFlag = checkLocalStorage();
        if (!cookie) {
            toggleBlockDataState(false, false, false);
            return { 'status': false };
        } else {
            // if there's a cookie the user has already approved and turned it on, change UI
            if (checkAttempt === 'init') {
                toggleBlockDataState(cookie, true);
                toggleLocationServiceUIState(true, true, true);
            }
            return { 'status': false, 'cookie': cookie }; 
        }
    };
    
    const removeOldClass = (cookie) => {
        const currentLocation = ourLocationsLatLong.filter((locationElm) => {
            if (locationElm.locationClass === cookieNameToCSSClass(cookie)) {
                return locationElm;
            }
        });
        currentClosestLocationClass = currentLocation[0].locationClass;
        const locationDisplayOverrideContainers = document.querySelectorAll('.location-display-override');
        locationDisplayOverrideContainers.forEach((container) => {

            if (container.classList.contains(currentClosestLocationClass)) {
                container.classList.remove(currentClosestLocationClass);
            }
        });
    };

    /* UI State management 
    * set block states and location services UI elements states
    */
    const toggleBlockDataState = (cookie, locationServiceActive) => {
        const blocks = document.querySelectorAll('.wrapper-location-block');
        const blockContainers = document.querySelectorAll('.custom-block');
        const locationDisplayOverrideContainers = document.querySelectorAll('.location-display-override');

        // Initially hide all blocks
        blocks.forEach((block) => {
            block.style.display = 'none';
        });

        if (locationServiceActive) {
            // Find block containers with multiple children, if there are multiple children
            // that means there's blocks for different regions
            blockContainers.forEach((container) => {
                const children = container.children;
                const childCount = children.length;

                if (childCount > 1) {
                    // There is location based data blocks to display
                    if (locationServiceActive && cookie) {
                        let cssClass= cookieNameToCSSClass(cookie);

                        // This is a temporary fix accounting for the change from Los Angeles to Greater Los Angeles. These classes are set in the templates for each block.
                        // The ACF group name is where the class that's added to an element comes from. To update the classes in the templates you have to update the ACF field names
                        // But if you update the ACF field names, then the links to any data in the DB breaks and you have to clean that up. I don't have time to do all that before
                        // the last deployment before my last day, so I'm just throwing a quick fix in here to get it working. This should be refactored tho.
                        if (cssClass === 'greater-los-angeles') {
                            cssClass = 'los-angeles'
                        }

                        let cookieClassFound = false;
                        let noLocationBlock;

                        if (locationDisplayOverrideContainers.length > 0) {
                            locationDisplayOverrideContainers.forEach((container) => {
                                container.classList.add(cssClass);
                            });
                        }

                        for (let i = 0; i < children.length; i++) {
                            const child = children[i];

                            if (child.classList.contains('no-location')) {
                                noLocationBlock = child;
                            }

                            if (child.classList.contains(cssClass)) {
                                cookieClassFound = true;
                                child.style.display = 'block';
                            }

                            if (i === children.length -1 && !cookieClassFound) {
                                if (noLocationBlock) {
                                    noLocationBlock.style.display = 'block';
                                    noLocationBlock = '';
                                }
                                cookieClassFound = false;
                            }
                        }
                    }

                } else {
                    // Block containers with only one child have no location based data to display
                    // so just find them all and display them
                    for (let child of children) {
                        child.style.display = 'block';
                    }
                }
            });
        } else {
            // Location service is off, so we're just looking for no-location blocks to display
            document.querySelectorAll('.no-location').forEach(block => {
                block.style.display = 'block';
            });
        }
        resizeBackground();
    };

    const toggleLocationServiceUIState = (checked, setToggleChecked, bypassGetLocation) => {
        const label = document.querySelector('.label-switch-location-service');
        const switchInput = document.getElementById('flexSwitchCheckDefault');
        if (label) {
            if (checked) { // service on
                if (!bypassGetLocation) {
                    getLocation();
                }
                label.style.color = '#00BA81';
            } else { // service off
                deleteCookie('biocom_location_service');
                label.style.color = '#D1CECE';
            }
        }

        if (switchInput && setToggleChecked) { // if there's a cookie onload, we want to set the UI accordingly
            switchInput.setAttribute('checked', '');
        }
    };
    
    const toggleLocationService = (event) => { 
        const checked = event.srcElement.checked;
        const cookie = checkCookie(); // returns an object
        const localStorageActiveFlag = checkLocalStorage();

        if (localStorageActiveFlag) {
            toggleLocationServiceUIState(checked, false, false);
            toggleBlockDataState(cookie, false, false);
            // at this point the location service is on, and the cookie exists, so cookie.cookie === region name
            if (cookie.cookie) {
                removeOldClass(cookie.cookie);
            }
        } else {
            toggleLocationServiceUIState(checked, true, false);
            toggleBlockDataState(cookie, true, false);
        }
    };

    const getLatLongFromZip = (zipCode) => {
        // TODO: Move this to the backend
        // Should be fine for now because this is a public google account scoped just to maps
        const apiKey = google_api_keys.google_api_key_dev.toString();
        fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`)
        .then(response => response.json())
        .then(data => {
            const result = data.results[0];
            const coordinates = result.geometry.location;
            const position = {
                coords: {
                    latitude: coordinates.lat,
                    longitude: coordinates.lng
                }
            }
            getLocationSuccess(position);
        });
    };
    
    /* Init calls
    * Method invocation, eventListeners - Everything is kicked off here onload
    */
    // The party starts here, check for an existing cookie
    checkCookie('init'); 

    // Location switch in utility menu
    if (formCheckInput) {
        formCheckInput.addEventListener('click', toggleLocationService); 
    };

    // Set location by zipcode in "Select Location" menu in utility menu
    const zipcodeForm = document.querySelector('#location-service-zipcode-form');
    if (zipcodeForm) {
        zipcodeForm.addEventListener('submit', function(e){
            e.preventDefault();
            e.stopPropagation();
            getLatLongFromZip(e.submitter.form[0].value);
        });
    };

    // Handles select location > choose a location links
    locationSelectLinks.forEach((link) => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const currentCookie = getCookie();
            let location = e.target.textContent;
            const locationFirstLetter = location.charAt(0).toLowerCase();
            location = location.replace(/\s+/g, '').split('.').join('');
            location = `${locationFirstLetter}${location.slice(1)}`;
            if (currentCookie) {
                removeOldClass(currentCookie);
            }
            setCookie('biocom_location_service', location, 7);
            toggleLocationServiceUIState(true, true, true);
            toggleBlockDataState(getCookie(), checkLocalStorage(), true) 
        });
    });

})();